import api from 'api'
import { queryParamSerializer } from 'lib/api/queryParamSerializer'
import type {
  JetAlertDateField,
  JetAlertSortBy,
  JetAlertSortDir,
  JetAlertStatus,
  JetAlertType,
} from 'pages/Jet/shared/constants/alertType'

export type JetAlertItem = {
  id: number
  jetInstanceId: number
  jetInstanceName: string
  alertType: JetAlertType
  // The thing the condition is about: shift id, assignment id, group key,
  // store id, or position id (see JET_ALERT_TYPE_KEY_HINTS).
  key: string
  lastAlertedAt: string
  // Null while the condition is live; stamped when it stops firing.
  resolvedAt: string | null
  createdAt: string
  updatedAt: string
  shiftId: number | null
  workerId: number | null
  workerName: string | null
  wsaStatus: string | null
}

export type JetAlertItems = JetAlertItem[]

export type ListJetAlertsRequest = {
  limit?: number
  // Opaque keyset cursor from a prior response's nextCursor; omit for page 1.
  cursor?: string
  alertTypes?: JetAlertType[] | null
  status?: JetAlertStatus | null
  dateField?: JetAlertDateField
  daysAgo?: number | null
  sortBy?: JetAlertSortBy
  sortDir?: JetAlertSortDir
}

export type ListJetAlertsResponse = {
  items: JetAlertItems
  // Null/absent once the list is exhausted.
  nextCursor?: string | null
  // Total rows matching the current filters, independent of the cursor window.
  totalCount: number
}

// Lists `jet_alert` rows (recurring/resolved jet-alert conditions), filtered by
// alert type, lifecycle status, and a days-ago window, ordered server-side and
// paginated by opaque keyset cursor.
export const listJetAlerts = async (
  request: ListJetAlertsRequest
): Promise<ListJetAlertsResponse> => {
  const params = {
    limit: request.limit,
    cursor: request.cursor,
    alert_types: request.alertTypes,
    status: request.status,
    date_field: request.dateField,
    days_ago: request.daysAgo,
    sort_by: request.sortBy,
    sort_dir: request.sortDir,
  }

  const response = await api.get<ListJetAlertsResponse>('/admin/jet/alerts', {
    params,
    paramsSerializer: queryParamSerializer,
  })
  return response.data
}
